<template>
    <!-- <div class="view"> -->
    <router-view class="view"></router-view>
    <!-- </div> -->
</template>

<script>
export default {
    created() {
        // 全局配置message
        this.$message.config({
            duration: 3
        });
    }
};
</script>

<style scoped lang="less">
.view {
    min-height: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue